'use strict';

window.DISTRIBUICAO_REGULAGEM_ADUBO = 50;
window.SEMENTES_SACO_MILHO = 60000;
window.TRATAMENTO_SEMENTE = 'ts';

angular
  .module('webAgro1App')
  // eslint-disable-next-line max-params, max-lines-per-function
  .factory('RecomendacoesSemeaduraService', function($http, RecomendacoesSemeaduraObjectService, RestService,
    DataService) {
    const TAXA_VARIACAO_MINIMA = 0.97;
    const TAXA_VARIACAO_MAXIMA = 1.03;
    const PESO_SACO = 40;

    const getTotalTratamentoRecomendado = function(tratamentos, cultivar) {
      return tratamentos.filter(function(tratamento) {
        return tratamento.cultivar.item_id === cultivar.item_id;
      }, []).reduce(function(sum, tratamento) {
        sum += tratamento.totalKg;
        return sum;
      }, 0);
    };

    const validarInsumosTratamento = function(valido, tratamentos) {
      tratamentos.forEach(function(tratamento) {
        if (!tratamento.insumos.length) {
          valido = false;
        } else {
          tratamento.insumos.forEach(function(insumo) {
            if (!insumo.dose) {
              valido = false;
            }
          });
        }
      });
      return valido;
    };

    const _addTotalKg = function(cultivar, valorKg, tipo) {
      if (tipo === TRATAMENTO_SEMENTE) {
        cultivar.totalKg = (cultivar.totalKg || 0) + valorKg;
      } else if (tipo === 'tsi') {
        cultivar.totalKgTSI = (cultivar.totalKgTSI || 0) + valorKg;
      }
    };

    return {
      list: function(filters) {
        const params = !filters ? {} : {
          page: filters.page || null,
          status: filters.status,
          safra: (filters.safra || {}).id
        };

        return RestService.getFromUrl(`${SERVER }v2/recomendacoes_semeadura`, params);
      },

      get: function(id) {
        return $http.get(`${SERVER }v2/recomendacoes_semeadura/${ id}`);
      },

      calculateDensidadeCorrigida: function(recommendation) {
        const densidade = recommendation.densidadeIdeal || 0;
        const pg = recommendation.pg || 0;
        const fatorCorrecao = recommendation.fatorCorrecao || 0;

        return fatorCorrecao < 0 ? 0 : parseInt((densidade / (pg / 100)) / ((100 - fatorCorrecao) / 100));
      },

      calculateRegulagem: function(recommendation, rawResults) {
        const densidadeCorrigida = recommendation.densidadeCorrigida || 0;
        const espacamento = recommendation.espacamento || 0;
        const distribuicaoRegulagem = recommendation.distribuicaoRegulagem || 0;
        const result = (densidadeCorrigida * espacamento * distribuicaoRegulagem) / TAXA_M2_HA;

        if (rawResults) {
          return {
            minima: result * TAXA_VARIACAO_MINIMA,
            maxima: result * TAXA_VARIACAO_MAXIMA,
            resultado: result
          };
        }
        return {
          minima: parseInt(result * TAXA_VARIACAO_MINIMA),
          maxima: parseInt(result * TAXA_VARIACAO_MAXIMA),
          resultado: result
        };
      },

      calculateQuantidade: function(recommendation) {
        let result;
        const densidadeCorrigida = recommendation.densidadeCorrigida || 0;
        if (!recommendation.isCorn) {
          const pms = recommendation.pms || 0;
          result = (densidadeCorrigida / TAXA_GRAMAS_KG) * (pms / TAXA_GRAMAS_KG);
        } else {
          result = densidadeCorrigida / SEMENTES_SACO_MILHO;
        }

        return {
          minima: result * TAXA_VARIACAO_MINIMA,
          maxima: result * TAXA_VARIACAO_MAXIMA,
          resultado: result
        };
      },

      calculateQuantidadeTotal: function(recommendation, margemSeguranca) {
        const quantidadeMaxima = margemSeguranca ?
          _.get(recommendation, 'quantidade.maxima', 0) :
          _.get(recommendation, 'quantidade.resultado', 0);
        const taxaCorrecao = recommendation.taxaCorrecao || 0;
        const area = _.get(recommendation, 'area', 0);

        const quantidadeTotal = quantidadeMaxima * area * ((taxaCorrecao + 100) / 100);

        return {
          total: quantidadeTotal,
          totalSacos: PESO_SACO <= 0 ? 0 : quantidadeTotal / PESO_SACO
        };
      },

      calculateQuantidadeTotalAdubo: function(recommendation) {
        const quantidadeMaxima = recommendation.dose || 0;
        const taxaCorrecao = recommendation.taxaCorrecao || 0;
        const area = (recommendation || {}).area || 0;

        const quantidadeTotal = quantidadeMaxima * area * ((taxaCorrecao + 100) / 100);

        return quantidadeTotal;
      },

      calculateQuantidadeRegulagemAdubacao: function(recommendation, adubo) {
        const dose = adubo.dose || 0;
        const distribuicaoRegulagem = recommendation.distribuicaoRegulagemAdubo || DISTRIBUICAO_REGULAGEM_ADUBO;
        const espacamento = recommendation.espacamento || 0;
        const areaTotal = recommendation.areaTotal || 0;

        return {
          regulagem: parseInt((dose * distribuicaoRegulagem * espacamento / TAXA_M2_HA) * TAXA_GRAMAS_KG),
          total: dose * areaTotal
        };
      },

      getAreaTotal: function(glebas) {
        return ((glebas || []).reduce(function(sum, gleba) {
          return sum + (gleba.area > 0 ? gleba.area : 0);
        }, 0)).toFixed(2);
      },

      validarTratamentoDeSementes(recomendacao) {
        let ok = true;
        const tratamentos = recomendacao.glebas.filter(function(gleba) {
          return gleba.ts === TRATAMENTO_SEMENTE;
        }, []);

        if (tratamentos.length && !recomendacao.tratamentos.length) {
          ok = false;
        }

        if (tratamentos.length) {
          const cultivares = this.listCultivaresParaTratar(recomendacao.glebas);
          cultivares.forEach(function(cultivar) {
            const totalRecomendado = getTotalTratamentoRecomendado(recomendacao.tratamentos, cultivar);
            if (totalRecomendado < +cultivar.totalKg.toFixed(2)) {
              ok = false;
            }
            if (totalRecomendado > +(cultivar.totalKg + cultivar.totalKgTSI).toFixed(2)) {
              ok = false;
            }
          });
          ok = validarInsumosTratamento(ok, recomendacao.tratamentos);
        }

        return ok;
      },

      listCultivaresParaTratar: function(glebas) {
        return glebas.reduce(function(group, gleba) {
          if (!gleba.ts || gleba.ts === 'none') {
            return group;
          }

          let cultivar = group.filter(function(grouped) {
            return grouped.item_id === gleba.cultivar.item_id;
          })[0];
          if (cultivar) {
            cultivar.data_inicio = DataService.getMinData(cultivar.data_inicio, gleba.data_inicio);
            cultivar.data_fim = DataService.getMaxData(cultivar.data_inicio, gleba.data_inicio);
            _addTotalKg(cultivar, +gleba.total.total.toFixed(2), gleba.ts);
          } else {
            cultivar = {
              item_id: gleba.cultivar.item_id,
              item_tipo: gleba.cultivar.tipo_item,
              descricao: gleba.cultivar.descricao,
              data_inicio: gleba.data_inicio,
              data_fim: gleba.data_fim_max,
              totalKg: 0,
              totalKgTSI: 0
            };
            _addTotalKg(cultivar, +gleba.total.total.toFixed(2), gleba.ts);
            group.push(cultivar);
          }
          return group;
        }, []);
      },

      autoFillCultivaresDestino(tratamentos, cultivaresDestinoTratamento) {
        (tratamentos || []).forEach((tratamento) => {
          if (!tratamento.cultivarDestino.item_id) {
            const cultivarDestino = cultivaresDestinoTratamento.find(
              (cultivar) => tratamento.cultivar.item_id === cultivar.codigo_semente_origem,
            );

            tratamento.cultivarDestino = cultivarDestino ? cultivarDestino : tratamento.cultivar;
          }
        });
      },

      getTotaisTratamento: function(cultivares, tratamentos) {
        return tratamentos.map(function(tratamento) {
          const found = cultivares.find(function(cultivar) {
            return cultivar.item_id === tratamento.cultivar.item_id;
          });

          if (!found) {
            return false;
          }

          tratamento.cultivar.totalKg = found.totalKg;
          tratamento.cultivar.totalKgTSI = found.totalKgTSI;
          return tratamento;
        }).filter(Boolean);
      },

      save: function(recomendacao) {
        const result = RecomendacoesSemeaduraObjectService.convertToSend(recomendacao);

        return $http({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          url: `${SERVER}v2/recomendacoes_semeadura`,
          data: { recomendacao_semeadura: result }
        });
      },

      update: function(recomendacao) {
        recomendacao = RecomendacoesSemeaduraObjectService.convertToSend(recomendacao);
        return $http.patch(`${SERVER}v2/recomendacoes_semeadura/${recomendacao.id}.json`, {
          recomendacao_semeadura: recomendacao
        });
      },

      delete: function(id) {
        return $http.delete(`${SERVER}v2/recomendacoes_semeadura/${id}`);
      },

      status: function(id) {
        return $http.get(`${SERVER}v2/recomendacoes_semeadura/${id}/status`);
      }
    };
  });
